// extracted by mini-css-extract-plugin
module.exports = {"flex":"NavigationDrawer__flex___kskkI","list":"NavigationDrawer__list___3jWe3","listItem":"NavigationDrawer__listItem___evXoj","poweredBy":"NavigationDrawer__poweredBy___3gqZS"};